import PropTypes from "prop-types";

export const AccentCoral = ({ children }) => {
  return <span className="accent-coral">{children}</span>;
};

AccentCoral.propTypes = {
  children: PropTypes.node,
};
